import React from "react";
import { NavLink } from "react-router-dom";
import { FaCheck, FaEye, FaPlayCircle } from "react-icons/fa";

import Config from "../../../config/config";

export default function ModuleCourseComponent({
   course,
   course_proof_type
  }) {

  return (
    <div key={course.id} className="course-item-sider-bar">
    <NavLink
      data-gtm-type="click"
      data-gtm-clicktype="link"
      data-gtm-name={`modulo_${course.title}`}
      activeClassName={"selected"}
      exact={true}
      to={"/curso/" + course.id}
    >
      <div className="course-item-icon">
        {!!course_proof_type
          ? (
            <FaCheck color={"#07a803"}/>
          )
          : (
            <FaEye color={"#009ee2"}/>
          )
        }
      </div>

      <img
        src={(course.thumbnail
          ? `${Config.baseUrl}/lms/assets/${course.thumbnail}`
          : (course.video && course.video.thumbnail
          ? course.video.thumbnail
          : "")
          )}
      />
      <div className="title">{course.title}</div>
    </NavLink>
  </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CoursePage/Components/ModuleCourseComponent.jsx